import {useState, createContext, useEffect} from 'react';
import api from '../../../config.js';
import './group.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa';
import { makeSearch, getPermission, showMessageError } from '../../../classes/functions';
import { Link } from 'react-router-dom';

import ReactTooltip from "react-tooltip";

export default function GroupEmpresas(){
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  const [listFinal, setListFinal] = useState([]);
  
  const [termSearch, setTermSearch] = useState('');

  //Paginação
  const [activePage, setActivePage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const [registerFrom, setRegisterFrom] = useState('');
  const [registerTo, setRegisterTo] = useState('');
  const [total, setTotal] = useState('');
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);

  useEffect(()=> {

    async function loadGroupEmpresas(){
      api.get("/api/group_companies/getList")
      .then((response) => {
          setList(response.data);
          setListAll(response.data);
          setPagination(response.data, itensByPage, termSearch);
          setCarrying(false);
        }
      ).catch((error) => {
        setCarrying(false);
        console.log(error);
        showMessageError(error.response.data);
      });
    }

    loadGroupEmpresas();

    return () => {

    }
  }, []);
  
  function search(e) {
    setTermSearch(e.target.value);
    setPagination(listAll, itensByPage, e.target.value);
  }

  function setPagination(aux_list_all = listAll, itensPerPage = itensByPage, auxTermSearch = termSearch) {
    let aux_list_total = [];

    aux_list_total = makeSearch(aux_list_all, ['nome'], auxTermSearch);

    setTotal(aux_list_total.length);

    if (aux_list_total.length > 0) {
      setTotalPage(parseInt(aux_list_total.length / itensPerPage)+1);
      let aux_list = [];
      let final_list = [];

      aux_list_total.forEach((element, index) => {
        if ((index+1) % itensPerPage === 0) {
          aux_list.push(element);
          final_list.push(aux_list);
          aux_list = [];
        } else {
          aux_list.push(element);
        }

        if ((aux_list_total.length === index+1) && (aux_list !== [])) {
          final_list.push(aux_list);
          aux_list = [];
        }
      });

      setList(final_list[0]);
      setListFinal(final_list);
      setRegisterFrom(1);
      setRegisterTo(final_list[0].length);
    } else {
      setList([]);
      setListFinal([]);
      setRegisterFrom(0);
      setRegisterTo(0);
    }
  }

  function nextPage () {
    if ((activePage) <= totalPage-2) {
      setList(listFinal[activePage+1]);
      setActivePage(activePage+1);

      setRegisterTo((((activePage+1)*itensByPage)+1) + (itensByPage-1));
      if (((((activePage+1)*itensByPage)+1) + (itensByPage-1)) > total) {
        setRegisterTo(total);
      }
      setRegisterFrom(((activePage+1)*itensByPage)+1);
    }
  }

  function lastPage () {
    setList(listFinal[totalPage-1]);
    setActivePage(totalPage-1);
    setRegisterTo(total);
    setRegisterFrom(((totalPage-1)*itensByPage)+1);
  }

  function firstPage () {
    setList(listFinal[0]);
    setActivePage(0);
    setRegisterFrom(1);
    setRegisterTo(listFinal[0].length);
  }

  function previewPage () {
    if ((activePage-1) >= 0) {
      setList(listFinal[activePage-1]);
      setActivePage(activePage-1);

      setRegisterTo((((activePage-1)*itensByPage)+1) + (itensByPage-1));
      if (((((activePage-1)*itensByPage)-1) + (itensByPage-1)) > total) {
        setRegisterTo(total);
      }
      setRegisterFrom(((activePage-1)*itensByPage)+1);
    }
  }
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Grupo de Empresas">
          {getPermission('CADASTROS - GRUPOS EMPRESAS - CADASTRO') && <Link to="/group_companies/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button> 
          </Link>}
          <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => {setItensByPage(e.target.value);setPagination(listAll, e.target.value);} }>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" type="text" onChange={search} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Nome">{item.nome}</td>
                    <td data-label="Opções">
                      {getPermission('CADASTROS - GRUPOS EMPRESAS - CADASTRO') && <Link className="action" to={`/group_companies/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/group_companies/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={2}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="divGroupPagination">
            <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft  color="#001675" size={17} /></button>
            <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo {registerFrom} a {registerTo} de {total} registros</label></center>
            </div>
            <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight  color="#001675" size={17} /></button>
        </div>
      </div>}
    </div>
  )
}